import React, { useId } from 'react';
import PageTitleLayout from '../../uiKit/pageTitleLayout';
import GamesList from '../gamesList';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useGetSettingsQuery } from '../../redux/api/admin';
import Paragraph from '../../uiKit/typography/paragraph';
import HeroBlock from '../heroBlock';
import GamesListFilters from '../gamesList/filters';
import { useQueryParams } from '../../utils/hooks/useQueryParams';

export default function GamesListPage() {
  const { t } = useTranslation('common');
  const { data: settings, isFetching: isFetchingSettings } = useGetSettingsQuery();
  const [searchParams, setSearchParams] = useQueryParams({
    type: value => value.split(',').map(id => Number(id)),
    // feature: value => value.split(',').map(id => Number(id)),
  });

  const gamesListNodeId = useId();

  const scrollToGames = () => {
    const node = document.getElementById(gamesListNodeId);
    if (node) node.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <>
      <HeroBlock showOverlay={false} showImage={false} className={'grid'} childWrapperClassName={'!items-start !pb-20'}>
        <div className={'w-full h-full flex flex-col items-center justify-between gap-14'}>
          <PageTitleLayout title={t('titles.games_list_page')}
                           className={'w-full max-w-4xl flex flex-col items-center text-center gap-4 md:gap-6 px-5 md:px-0'}>
            <Paragraph className={'!text-white md:w-2/3'}>
              {t('descriptions.games_list_page')}
            </Paragraph>
            <div className={'flex flex-col w-full md:w-fit gap-4 md:flex-row justify-around items-center box-border'}>
              <NavLink to={'/contacts'} className={' w-full'}>
                  <span
                    className={'block py-2 px-4 text-white text-base overflow-hidden border border-white rounded-lg whitespace-nowrap'}>
                    <span className={'relative z-[1]'}>
                      {t('buttons.become_partner')}
                    </span>
                  </span>
              </NavLink>
              <button onClick={scrollToGames} className={'block w-full text-white'}>
                  <span
                    className={'block py-2 px-4 bg-white text-base overflow-hidden rounded-lg '}>
                    <span className={'relative text-black z-[1] select-none'}>
                      {t('buttons.our_games')}
                    </span>
                  </span>
              </button>
            </div>
          </PageTitleLayout>

          <div className={'w-full px-5 md:px-28'}>
          <GamesListFilters searchParams={searchParams} setSearchParams={setSearchParams} />
          </div>
        </div>
      </HeroBlock>

      <div className={'flex flex-col items-center w-full py-20 px-4 md:px-12 2xl:px-44 md:pt-24 md:pb-32'}>
        <GamesList searchParams={searchParams} gamesListNodeId={gamesListNodeId} />
      </div>
    </>
  );
}
